import React from 'react';
import { Link } from 'react-router-dom';
import {
  repositoryCommitsColumns,
  repositoryPullRequestsColumns,
} from '../RepositoryDetail/repositoryDetailColumns';

const repositoryLinkColumn = {
  id: 'repository',
  accessorFn: (row) => row.repository || row.repositoryId || '',
  header: 'Repository',
  enableGlobalFilter: false,
  meta: { tdClassName: 'px-4 py-3 text-sm align-top min-w-[8rem]' },
  cell: ({ row }) => {
    const r = row.original;
    const id = r.repositoryId;
    const name = r.repository || id || '—';
    if (!id) return <span className="text-slate-400">{name}</span>;
    return (
      <Link
        to={`/repositories/${id}`}
        className="text-brand-teal-light hover:underline truncate block max-w-[14rem]"
      >
        {name}
      </Link>
    );
  },
};

function insertAfterColumnId(columns, columnId, insertCol) {
  const idx = columns.findIndex((c) => c.id === columnId);
  if (idx < 0) return [...columns, insertCol];
  return [...columns.slice(0, idx + 1), insertCol, ...columns.slice(idx + 1)];
}

export const dashboardCommitsColumns = insertAfterColumnId(
  repositoryCommitsColumns,
  'commit',
  repositoryLinkColumn
);

export const dashboardPullRequestsColumns = insertAfterColumnId(
  repositoryPullRequestsColumns,
  'pr',
  repositoryLinkColumn
);
